// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/callback","layout":false,"id":"3"},"4":{"path":"/dashboard","name":"dashboard","icon":"dashboard","parentId":"ant-design-pro-layout","id":"4"},"5":{"path":"/users","name":"users","icon":"user","access":"canReview","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/topics","name":"topics","icon":"tags","access":"canReview","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/posts","name":"posts","icon":"read","access":"canReview","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"/","redirect":"/dashboard","parentId":"ant-design-pro-layout","id":"8"},"9":{"path":"*","layout":false,"id":"9"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__callback" */'@/pages/callback.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Dashboard" */'@/pages/Dashboard.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__Users" */'@/pages/Users.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__Topics" */'@/pages/Topics.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__Posts" */'@/pages/Posts.tsx')),
'8': React.lazy(() => import('./EmptyRoute')),
'9': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/app/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
